import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { selectUserId } from 'store/auth/selectors';

const signedOutTitle = 'App Sign In | RiskBase';
const signedOutDescription =
  'Sign in to your RiskBase account to complete risk assessments, survey residents, manage your assets & more.';

const signedInTitle = 'App | RiskBase';
const signedInDescription =
  'Complete risk assessments, survey residents, manage your assets & more in RiskBase.';

const setMetaDescription = (description: string) => {
  const metaDescription = document.querySelector<HTMLMetaElement>(
    'meta[name="description"]',
  );

  if (metaDescription) {
    metaDescription.content = description;
  }
};

export const DocumentHead = () => {
  const userId = useSelector(selectUserId);

  React.useEffect(() => {
    document.title = userId ? signedInTitle : signedOutTitle;
    setMetaDescription(userId ? signedInDescription : signedOutDescription);
  }, [userId]);

  return null;
};
